module.exports = __webpack_public_path__ + "img/symbol-defs.9578232.svg";